import { render } from "./list.html?vue&type=template&id=580e8777&ts=true"
import script from "./list.ts?vue&type=script&lang=ts"
export * from "./list.ts?vue&type=script&lang=ts"

import "./list.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__